import { Map, fromJS, List } from 'immutable';

import * as constAction from 'root/actionConstants';

const defaultState = Map({
  userId: null,
  nombre: null,
  apellido: null,
  access_token: null,
  roles: List(),
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.USER_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    case constAction.USER_LOGOUT: {
      return Map(defaultState);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/modules/user/reducer.js